import styled from 'styled-components';
import { Box, Button as MUIButton } from '@mui/material';

export const Container = styled(Box)`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  padding: ${({ theme }) => theme.spacing(9, 0, 6, 0)};
`;

export const Content = styled(Box)`
  width: 100%;
`;

export const ButtonsWrapper = styled(Box)`
  display: flex;
  column-gap: 24px;
`;

export const NextButton = styled(MUIButton)`
  &:not(:disabled) {
    background-color: ${({ theme }) => theme.palette.primary.main} !important;
  }
`;

NextButton.defaultProps = {
  variant: 'contained',
};

export const PrevButton = styled(MUIButton)`
  &:not(:disabled) {
    border-color: ${({ theme }) => theme.palette.primary.main} !important;
    color: ${({ theme }) => theme.palette.primary.main} !important;
  }
`;

PrevButton.defaultProps = {
  variant: 'outlined',
};
